import '../../components/styles/customstyle.scss'

import * as sync from '../../../src/syncWorker'

import { AVAILABLE_ENTITIES, utils } from '../../database'
import AppContent from '../../components/layout/AppContent'
import React, { Component } from 'react'
import { USUARIO, formatName } from '../../utils/formHelper'

import { Box } from '@mui/material'
import Button from '../../components/material/Button'
import LogoutFlow from '../../components/localReset/LogoutFlow'
import { connect } from 'react-redux'
import { getLoggedUser } from '../../redux/auth/actions'
import { logout } from '../../redux/auth/actions'
import { withRouter } from '../../utils/withRouterCompat'

class Backup extends Component {
  constructor(props) {
    super(props)
    this.state = { logoutFlow: false }
  }

  async downloadBackup() {
    try {
      await sync.downloadBackup(formatName('props.user.nomeCompleto', USUARIO))
    } catch {
      alert('Não foi possível gerar o backup. Tente novamente.')
    }
  }

  render() {
    return (
      <AppContent>
        <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
          <Button label='backup' onClick={() => this.downloadBackup()} />
          <Button
            label='sair'
            onClick={() => this.setState({ logoutFlow: true })}
          />
        </Box>
        {this.state.logoutFlow && (
          <LogoutFlow
            onLoggedOut={() => this.props.logout()}
            onClose={() => this.setState({ logoutFlow: false })}
          />
        )}
      </AppContent>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  logout: async () => await dispatch(logout()),
  loggedUser: async () => await getLoggedUser(),
  user: async () =>
    await utils.getElement(AVAILABLE_ENTITIES.USERS, loggedUser.userId),
})

export default connect(null, mapDispatchToProps)(withRouter(Backup))
